<template>
  <component
    :is="iconComponent"
    role="img"
    class="custom-svg-icon"
    :data-icon="name"
    :style="{ scale: scale }"
  />
</template>

<script>
const icons = {
  address_book: require("@/assets/icons/AddressBookIcon.vue").default,
  arrow_ext: require("@/assets/icons/ArrowExt.vue").default,
  arrow_in: require("@/assets/icons/ArrowIn.vue").default,
  bell: require("@/assets/icons/Bell.vue").default,
  chevron_down: require("@/assets/icons/ChevronDown.vue").default,
  chevron_right: require("@/assets/icons/ChevronRight.vue").default,
  chevron_right_rounded: require("@/assets/icons/ChevronRightRounded.vue")
    .default,
  chevron_right_last_rounded:
    require("@/assets/icons/ChevronRightLastRounded.vue").default,
  circled_checked: require("@/assets/icons/CircledCheck.vue").default,
  circled_ko: require("@/assets/icons/CircledKo.vue").default,
  circled_plus: require("@/assets/icons/CircledPlus.vue").default,
  close: require("@/assets/icons/CloseIcon.vue").default,
  difference: require("@/assets/icons/DifferenceIcon.vue").default,
  download: require("@/assets/icons/DownloadIcon.vue").default,
  edit: require("@/assets/icons/Edit.vue").default,
  eye: require("@/assets/icons/Eye.vue").default,
  fattutto: require("@/assets/icons/Fattutto.vue").default,
  filters: require("@/assets/icons/Filters.vue").default,
  loading: require("@/assets/icons/LoadingIcon.vue").default,
  options: require("@/assets/icons/Options.vue").default,
  primary: require("@/assets/icons/PrimaryIcon.vue").default,
  relations: require("@/assets/icons/Relations.vue").default,
  search: require("@/assets/icons/Search.vue").default,
  send: require("@/assets/icons/Send.vue").default,
  sepa: require("@/assets/icons/SepaIcon.vue").default,
  trash: require("@/assets/icons/Trash.vue").default,
  email_error: require("@/assets/icons/EmailErrorIcon.vue").default,
  email_success: require("@/assets/icons/EmailSuccessIcon.vue").default,
  reload: require("@/assets/icons/Reload.vue").default,
};

export default {
  name: "BaseIcon",
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value);
      },
    },
    scale: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name];
    },
  },
};
</script>
